<template>
  <div class="project-content container">
    <div class="project-content__content" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: "ProjectContent",
  props: {
    content: String
  },
  methods: {
    //
  }
};
</script>

<style lang="sass">
.project-content
  padding: 4rem 0
  /*background-color: #F8F9F8*/
  &__content
    max-width: 756px
    margin: 0 auto
    img, iframe
      width: 100%
      padding: 2rem 0
  @media screen and (max-width: 502px)
    &__content
      padding: 0 2rem
</style>
